import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert, Button, ModalBody, ModalFooter } from 'reactstrap';

interface ConflictStepProps {
  conflictingColumns: string[];
  onBack: () => void;
  onClose: () => void;
}

const ConflictStep: FC<ConflictStepProps> = ({
  conflictingColumns,
  onBack,
  onClose,
}) => (
  <>
    <ModalBody>
      <Alert color="danger">
        <FormattedMessage
          id="app.custom_campaign_data.conflict.message"
          defaultMessage="The following columns are owned by other users and cannot be overwritten. Please go back and remap or remove these columns."
        />
      </Alert>
      <ul>
        {conflictingColumns.map((key) => (
          <li key={key}>{key}</li>
        ))}
      </ul>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onBack}>
        <FormattedMessage
          id="app.custom_campaign_data.conflict.back"
          defaultMessage="Back"
        />
      </Button>
      <Button color="primary" onClick={onClose}>
        <FormattedMessage
          id="app.custom_campaign_data.conflict.close"
          defaultMessage="Close"
        />
      </Button>
    </ModalFooter>
  </>
);

export default ConflictStep;
